import classNames from 'classnames'
import './SecurityDialog.layout.scss'

export const SecurityDialogLayout = defineComponent({
  name: 'SecurityDialogLayout',
  inheritAttrs: false,
  setup(_, { slots, attrs }) {
    return () => (
      <div {...attrs} class={classNames('security-dialog-layout', attrs.class as string)}>
        {slots.default?.()}
      </div>
    )
  },
})
